var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpgradeEnterpriseSendSuccess = function SvgUpgradeEnterpriseSendSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 324,
    viewBox: "0 0 311 324",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M269.588 86.547C298.533 134.12 308.853 187.278 306.869 228.863C304.678 270.934 290.182 301.419 264.783 314.947C239.136 328.605 205.857 324.427 169.104 312.847C132.577 300.804 92.5767 281.37 58.9103 253.879C-8.67481 201.824 -21.3582 114.426 39.8609 43.9492C100.56 -26.3479 212.568 -12.324 269.588 86.547Z",
    fill: "#FFD763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286 110H29V254C29 258.418 32.5817 262 37 262H278C282.418 262 286 258.418 286 254V110Z",
    fill: "#AE84D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M278 86H37C32.5817 86 29 89.5817 29 94V110H286V94C286 89.5817 282.418 86 278 86Z",
    fill: "#7038A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 96.994C50 99.7572 47.7551 102 45.0018 102C42.2348 102 40 99.7572 40 96.994C40 94.2309 42.2348 92 45.0018 92C47.7551 92 50 94.2309 50 96.994Z",
    fill: "#CFD6F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96.994C65 99.7572 62.7626 102 60.0015 102C57.2386 102 55 99.7572 55 96.994C55 94.2309 57.2386 92 60.0015 92C62.7626 92 65 94.2309 65 96.994Z",
    fill: "#EAF4FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79 96.994C79 99.7572 76.9859 102 74.4995 102C72.0146 102 70 99.7572 70 96.994C70 94.2309 72.0146 92 74.4995 92C76.9859 92 79 94.2309 79 96.994Z",
    fill: "#EAF4FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5478 210.218C74.2286 211.368 78.1522 212.393 82.2827 213.306L80.8077 216.256C76.5982 215.327 72.5882 214.276 68.813 213.098L70.5478 210.218Z",
    fill: "#7038A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236.963 246.684C239.336 241.766 240.715 236.265 240.715 230.433C240.715 209.768 223.961 193.002 203.286 193.002C182.607 193.002 165.844 209.768 165.844 230.433C165.844 236.265 167.212 241.766 169.599 246.684H236.963Z",
    fill: "#C5E1F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.204 231.817C250.204 240.009 243.563 246.651 235.37 246.651C227.179 246.651 220.531 240.009 220.531 231.817C220.531 223.63 227.179 216.989 235.37 216.989C243.563 216.989 250.204 223.63 250.204 231.817Z",
    fill: "#C5E1F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.027 217.619C134.027 233.637 121.04 246.625 105.012 246.625C88.9881 246.625 76 233.637 76 217.619C76 201.589 88.9881 188.607 105.012 188.607C121.04 188.607 134.027 201.589 134.027 217.619Z",
    fill: "#C5E1F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.463 213.192C238.463 231.086 223.96 245.601 206.067 245.601C188.16 245.601 173.656 231.086 173.656 213.192C173.656 195.304 188.16 180.795 206.067 180.795C223.96 180.795 238.463 195.304 238.463 213.192Z",
    fill: "#C5E1F9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.067 180.795C188.16 180.795 173.656 195.304 173.656 213.192C173.656 217.748 174.604 222.083 176.305 226.02C182.022 231.079 189.524 234.188 197.766 234.188C215.659 234.188 230.161 219.673 230.161 201.779C230.161 197.223 229.211 192.888 227.515 188.957C221.796 183.892 214.306 180.795 206.067 180.795Z",
    fill: "#EAF4FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M207.85 246.684C210.228 241.766 211.601 236.265 211.601 230.433C211.601 209.768 194.841 193.002 174.173 193.002C153.488 193.002 123.603 209.768 123.603 230.433C123.603 236.265 101.137 241.766 103.521 246.684H207.85Z",
    fill: "#C5E1F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M198.414 188.525C198.414 214.777 177.139 236.062 150.886 236.062C124.626 236.062 103.344 214.777 103.344 188.525C103.344 162.285 124.626 141 150.886 141C177.139 141 198.414 162.285 198.414 188.525Z",
    fill: "#C5E1F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.736 219.462C161.992 219.462 183.261 198.177 183.261 171.925C183.261 164.438 181.523 157.355 178.436 151.051C170.379 144.759 160.243 141 149.224 141C122.965 141 101.682 162.285 101.682 188.525C101.682 188.635 101.692 188.74 101.692 188.85C87.2349 190.494 76 202.752 76 217.653C76 222.167 77.0633 226.423 78.8969 230.231C81.6509 231.445 84.6876 232.138 87.8911 232.138C99.5001 232.138 109.02 223.252 110.06 211.926C117.465 216.685 126.271 219.462 135.736 219.462Z",
    fill: "#EAF4FE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.971 138.476L278.482 113L220.928 141.471L203.971 138.476Z",
    fill: "#7038A7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M220.722 156.594L278.328 113L218.479 141.423L220.722 156.594Z",
    fill: "#905CC4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.848 156.424L278.483 113L228.743 145.371L220.848 156.424Z",
    fill: "#5B2492"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.468 164.949L278.459 113L228.643 145.433L251.468 164.949Z",
    fill: "#7038A7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2481 177.755C61.5162 174.185 63.8193 170.847 66.1572 167.78L64.0417 165.166C61.6456 168.312 59.2892 171.722 56.9788 175.362L59.2481 177.755ZM73.8227 158.836C76.6703 155.935 79.5429 153.473 82.4198 151.506L80.9326 148.291C77.8912 150.368 74.8897 152.943 71.9467 155.949L73.8227 158.836ZM92.0483 146.847C93.0126 146.577 93.9801 146.368 94.9456 146.223C97.4307 145.851 99.9029 145.898 102.373 146.399L102.614 142.827C99.8727 142.271 97.1315 142.221 94.4065 142.63C93.3496 142.789 92.2916 143.017 91.2432 143.311L92.0483 146.847ZM112.333 150.996C115.207 153.1 118.088 155.913 120.954 159.518L122.878 157.041C119.841 153.226 116.751 150.191 113.614 147.894L112.333 150.996ZM128.13 170.281C130.146 173.828 132.151 177.806 134.136 182.237L136.582 180.632C134.551 176.088 132.487 171.987 130.393 168.308L128.13 170.281ZM139.254 194.861C140.009 196.892 140.756 198.995 141.498 201.17C141.999 202.641 142.331 204.003 142.519 205.256C142.637 206.04 142.696 206.782 142.713 207.481L145.56 207.651C145.541 206.747 145.459 205.808 145.313 204.837C145.08 203.284 144.683 201.65 144.1 199.943C143.342 197.733 142.583 195.595 141.817 193.526L139.254 194.861ZM138.17 216.638C137.487 216.992 136.768 217.227 136.037 217.337C134.849 217.516 133.645 217.357 132.549 216.867C131.459 216.375 130.485 215.566 129.685 214.399L127.592 216.644C128.762 218.369 130.234 219.574 131.787 220.269C133.346 220.966 134.988 221.168 136.576 220.93C137.553 220.783 138.505 220.472 139.416 219.999L138.17 216.638ZM127.993 202.578C128.14 201.53 128.341 200.417 128.602 199.241C128.877 198.033 129.37 196.922 130.093 195.861C130.822 194.8 131.782 193.8 132.967 192.866L131.343 189.751C129.991 190.818 128.82 192.008 127.885 193.373C126.951 194.736 126.254 196.282 125.865 198.009C125.573 199.294 125.349 200.525 125.187 201.704L127.993 202.578ZM142.523 187.994C145.638 186.876 149.157 185.877 152.938 184.915L152.183 181.366C148.363 182.338 144.788 183.352 141.568 184.507L142.523 187.994ZM163.557 182.379C167.023 181.573 170.601 180.738 174.213 179.822L173.459 176.272C169.874 177.182 166.307 178.014 162.842 178.819L163.557 182.379ZM184.821 176.86C188.359 175.761 191.861 174.535 195.278 173.131L194.223 169.681C190.884 171.054 187.437 172.259 183.954 173.342L184.821 176.86ZM205.404 168.201C208.769 166.258 211.954 164.052 214.88 161.516L213.157 158.48C210.376 160.891 207.324 163.01 204.071 164.888L205.404 168.201Z",
    fill: "#7038A7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3582 184.052C56.6761 187.469 56.3442 191.238 56.3366 195.303L52.9766 194.55C52.9793 190.344 53.3244 186.404 54.0464 182.792L57.3582 184.052Z",
    fill: "#7038A7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5864 205.892C64.3421 206.511 65.1466 207.087 65.9937 207.621L63.914 210.592C62.9928 210.012 62.113 209.381 61.2858 208.705C59.1531 206.96 57.3492 204.895 55.9208 202.49L58.7291 200.271C60.017 202.437 61.642 204.301 63.5864 205.892Z",
    fill: "#7038A7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 228.612,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.611,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.17,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.25,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.891,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.529,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 256.831,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 262.47,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 268.11,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 273.749,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 279.389,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 228.612,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.83,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.389,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.469,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 298.109,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 228.611,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 234.251,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 239.89,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 245.53,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.748,
    cy: 251.169,
    r: 1.61129,
    fill: "#7038A7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpgradeEnterpriseSendSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upgrade-enterprise-send-success.a19dadf3.svg";
export { ForwardRef as ReactComponent };